<template>
  <main class="aboutus__main" >
    <!-- <Breadcrumb :items="[{ to: '/about-us', title: 'سوالات متداول' }]" /> -->
    <PagesPath path-title1="سوالات متداول"  />

    <section class="main_container">
        <figure >
            <img src="../../../assets/images/faqs.png" class="w-100" alt="" />
        </figure>
        <div class="mb-8" ><h3 class="font-900 text-xl font-heavy py-4 title" >سوالات متداول</h3></div>
      <div class="questions w-100" >
        <details name="group" v-for="(faq,index) in FaqList" :key="index">
          <summary
            class=""
            
          >
            <span class="font-s-14-mob" 
              >
              {{ faq.question }}
              </span
            ><span 
              ><svg
                class="icon-summery"
                width="12"
                height="16"
                viewBox="0 0 16 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.8755 27.7747C13.6427 27.7747 13.4081 27.7156 13.1933 27.5883C11.8432 26.7874 1.23978e-05 19.6057 1.23978e-05 13.8879C1.23978e-05 8.17201 11.8414 0.988512 13.1933 0.187559C13.8289 -0.19052 14.6562 0.0209172 15.0322 0.660605C15.41 1.30029 15.1988 2.12454 14.5613 2.50262C9.97011 5.22443 2.68592 10.7217 2.68592 13.8879C2.68592 17.0595 9.97011 22.5551 14.5613 25.2733C15.1988 25.6514 15.41 26.4756 15.0322 27.1153C14.7815 27.5382 14.3357 27.7747 13.8755 27.7747Z"
                  fill="black"
                  
                ></path></svg
            ></span>
          </summary>
          <p class="font-light py-2 px-4 py-lg-4 rounded-[40px] bg-white" >
           {{ faq.answer }}
          </p>
          
        </details>
     

      </div>
    </section>

  </main>

</template>

<script>

import PagesPath from "@/parts/Front/components/PagesPath";

export default {
  name: "faqs",
  components: {
    PagesPath
  },
  mounted() {
    this.$store.dispatch('front/getAllFaqListFromServer')
 
  },
  computed: {
 
        FaqList() {
          if(this.$store.getters["front/getFaqList"]!=null){
        return this.$store.getters["front/getFaqList"]
      }else{
        return []
      }
  },

}
}
</script>

<style scoped>
details {
    cursor: pointer;
}
details summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f3f6f9;
    border-radius: 15px;
    color: #1e1c26;
    list-style-type: none;
    margin-bottom: 1rem;
    padding: 16px 10px;
}
 .icon-summery {
    transform: translateY(3px) ;
}
details[open] .icon-summery {
    transform: translateY(5px) rotate(-90deg);
}
.main_container {
    margin-left: auto;
    margin-right: auto;
    padding: 11px;
    width: 97%;
}
@media screen and (min-width: 1024px) {
    .main_container {
        margin: 0 auto;
        max-width: 900px;
        padding: 15px;
    }
}
</style>
